import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParamsContextProvider } from '../../../../../hooks/ParamsContextProvider';
import { useNavigate } from 'react-router-dom';
import { TABLES } from '../../../../../Apis/Tables';
import { useTranslation } from 'react-i18next';
import { VIEW_TYPE } from '../../../../../enums/ViewType';
import { DeleteItemsApi } from '../../../../../reduxToolkit/Commons/CommonsApi';
import { SimpleSearch} from './../../../../../reduxToolkit/Search/SearchApi';
import {
    DEFAULT_LEFT,
    LEFT_FIRST_COLUMN_WITH_CHECKBOX,
    LEFT_SECOND_COLUMN_WITH_CHECKBOX,
    LEFT_SECOND_COLUMN_WITHOUT_CHECKBOX,
    SEARCH_MODEL,
    WIDTH_COLUMN_FIXED, WIDTH_TOOLTIP_FIXED_COLUMN
} from '../../../../../components/table/Model/TableModel';
import { SUB_VIEW_MODEL, TABS_FOODIE } from '../../Model/Models';
import routes from '../../../../../Routes/routes';
import TableFunction from '../../../../../components/table/TableFunction';
import CustomChip from './../../../../../components/CustomChip';
import {
    GetAllCourseType,
    GetAllMeals,
} from '../../../../../reduxToolkit/FoodieMenu/MenuApi';
import {
    CloneIconOptions,
    DeleteIconsOptions,
    DetailsIconsOptions,
    UpdateIconsOptions
} from '../../../../../components/buttons/IconButtons';
import DropDownMenuProfile from '../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from '../../../../../components/DropDown/DropDownMenuItem';
import {permissionObj} from './../../../../../Helpers/permission';
import { militaryHourToTimeString} from '../../../../../utils/TimeConversion';
import { GetAllCafeterias } from '../../../../../reduxToolkit/FoodieShift/FoodieShiftApi';
import { colors } from '../../../../../enums/colors';
import {DishCategoryEnum, MealTypeEnum} from '../Model/Model';
import {
    DATE_TIME_FORMAT_NAME_MODEL,
    EMPTY_VALUES,
    errorMsg
} from '../../../../../Apis/functions';
import {toast} from "react-toastify";
import {MODELS} from "../../../../../Apis/Models";
import CustomTooltip from "../../../../../components/CustomTooltip";
import {clearGetAllMealForecast} from "../../../../../reduxToolkit/FoodieMenu/MenuSlice";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const MenuApp = ({
    setBodyForExport,
    modified,
    setModified,
    searchElement,
    setSearchElement,
    subView,
    setSubView,
    option,
    setOption,
    setModuleId
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [view, setView] = useState(VIEW_TYPE.LIST.name);
    const { t } = useTranslation();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const { getAllMealForecast } = useSelector((state) => state.MenuSlice);
    const searchId = "txt_ma_search_menus";
    const { paramsContext, setParamsContext } = useParamsContextProvider();
    const [selectForDelete, setSelectForDelete] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [resultsToShow, setResultsToShow] = useState([]);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const deletePermission = DEV || permission.includes(permissionObj?.WEB_FOODIE_MENU_DELETE);

    /**
     * Checks if a given release date and hour is in the future.
     * - Converts `releaseDate` (milliseconds since 1970) to a Date object.
     * - Extracts hours and minutes from `releaseHour` (military time, e.g., 200 -> 02:00, 1530 -> 15:30).
     * - Sets the extracted hours and minutes on the base date.
     * - Compares the resulting date/time with the current date/time.
     *
     * @param date number - The release date in milliseconds since 1970.
     * @param militaryHour number - The release hour in military format (HHMM).
     * @returns boolean - True if the release date/time is in the future, false otherwise.
     */

    const isFutureDate = (item) => {
        const baseDate = new Date(item.releaseDate);
        const hours = Math.floor(item.releaseHour / 100);
        const minutes = item.releaseHour % 100;
        baseDate.setHours(hours, minutes, 0, 0);

        // Return true if baseDate is greater than the current date/time
        return baseDate > new Date();
    }

    useEffect(() => {
        // Returning from a detail the subview arrives already set, so the default one
        // must not overwrite the view the user came from
        if (subView) return;

        if (DEV || permission?.includes(permissionObj?.WEB_FOODIE_MENU_READ)) {
            handleShowMenu();
            return;
        }

        if (DEV || permission?.includes(permissionObj?.WEB_FOODIE_MEAL_FORECAST_READ)) {
            handleShowMealForecast();
        }
    }, [paramsContext?.tabIndex, subView]);

    // Show delete modal if tab is "Menus" and there are items selected for deletion
    useEffect(() => {
        if (paramsContext && paramsContext?.tabIndex === TABS_FOODIE.MENUS.INDEX && selectForDelete?.length > 0)
            setDeleteModalShow(paramsContext.modalDelete);
    }, [paramsContext]);

    // Enable or disable the delete button based on the selection
    useEffect(() => {
        if (paramsContext && paramsContext?.tabIndex === TABS_FOODIE.MENUS.INDEX) {
            setParamsContext((prev) => ({
                ...prev,
                disabledBtnDelete: selectForDelete?.length <= 0,
            }));
        }
    }, [selectForDelete]);

    // Clear selected items when the delete modal is closed
    useEffect(() => {
        if (!deleteModalShow) setSelectForDelete([]);
    }, [deleteModalShow]);


    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: option,
            key: searchElement,
            view
        });

        setBodyForExport(body);

        dispatch(SimpleSearch({ body })).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setResultsToShow(data);
                }
            },
        );
    }

    // Table logic, selection and pagination setup
    const {
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage,
        openMenu,
        handleMenuToggle,
        handleClose,
    } = TableFunction({
        selectedList: selectForDelete,
        setSelectedList: setSelectForDelete,
        data: resultsToShow,
        labelRowsPerPage: 'menus_per_page',
        setIsAllChecked,
        hasContainer: true,
        fixedPagination: false,
        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    // Load essential data on component mount
    useEffect(() => {
        dispatch(GetAllCafeterias());
        dispatch(GetAllCourseType());
    }, []);

    useEffect(() => {
        if(subView === SUB_VIEW_MODEL.MENUS.MENUS) {
            dispatch(GetAllMeals());
            getData(0, {searchElement:''});
        }
    }, [subView]);

    // Delete selected items from the table
    const handleDeleteSelected = () => {
        if (selectForDelete.length > 0) {
            dispatch(DeleteItemsApi({ tableName: TABLES.MENU, body: selectForDelete })).then(
                ({
                    payload: {
                        data: { success, code },
                    },
                }) => {
                    if (success === true) {
                        setModified(true);
                        setSelectForDelete([]);
                        setIsAllChecked(false);
                        handleDeleteModalClose();
                    } else errorMsg(code);
                },
            );
        }
    };

    // Mark a specific item for deletion and open the modal
    const handleDeleteItem = (item) => {
        setParamsContext((prev) => ({
            ...prev,
            modalDelete: true,
        }));
        setSelectForDelete([item.id]);
    };

    // Close the delete confirmation modal
    const handleDeleteModalClose = () => {
        if (setParamsContext) {
            setParamsContext((prev) => ({
                ...prev,
                modalDelete: false,
            }));
        }
    };

    // Show menu subview
    const handleShowMenu = () => {
        if(subView === SUB_VIEW_MODEL.MENUS.MENUS) return;
        clear();
        setSubView(SUB_VIEW_MODEL.MENUS.MENUS);
        setOption(TABLES.MENU);
        setModuleId(MODELS.FOODIE_MENU);
    };

    // Show calendar subview
    const handleShowCalendar = () => {
        if(subView === SUB_VIEW_MODEL.MENUS.CALENDAR) return;
        clear();
        setSubView(SUB_VIEW_MODEL.MENUS.CALENDAR);
    };

    const handleShowMealForecast = () => {
        if(subView === SUB_VIEW_MODEL.MENUS.MEAL_FORECAST) return;
        clear();
        setSubView(SUB_VIEW_MODEL.MENUS.MEAL_FORECAST);
        setOption(TABLES.FOODIE_MEAL_FORECAST);
        setModuleId(MODELS.FOODIE_MEAL_FORECAST);
    };

    /**
     * Clears the current search and selection state.
     *
     * This function resets all related states including:
     * - The list of results to show.
     * - The current search input.
     * - The "select all" checkbox state.
     * - The list of items selected for deletion.
     * It also dispatches an action to clear the meal forecast data from the store.
     */
    const clear = () => {
        setResultsToShow([]);
        setSearchElement('');
        setIsAllChecked(false);
        setSelectForDelete([]);
        dispatch(clearGetAllMealForecast());
    }

    const searchMealForecast = (search) => {
        if(!getAllMealForecast){
            setResultsToShow([]);
            return;
        }

        if (!search) {
            setResultsToShow(getAllMealForecast);
            toast.success(t('search_completed_successfully'));
            return;
        }

        const lowerSearch = search.toLowerCase();
        setResultsToShow(getAllMealForecast.filter(row => row.meal?.foodieItemName?.toLowerCase()?.includes(lowerSearch)));
        toast.success(t('search_completed_successfully'));
    };

    // Columns definition for the table
    const columns = [
        {
            field: 'foodieItemName',
            label: t('meals'),
            fixed: true,
            left: deletePermission ? LEFT_FIRST_COLUMN_WITH_CHECKBOX : DEFAULT_LEFT,
            customWidth: WIDTH_COLUMN_FIXED,
            classNameContainerTooltip: WIDTH_TOOLTIP_FIXED_COLUMN,
            render: (value) => {
                return value;
            },
        },
        {
            field: 'foodieCafeteriaName',
            label: t('diner'),
            fixed: true,
            left: deletePermission ? LEFT_SECOND_COLUMN_WITH_CHECKBOX: LEFT_SECOND_COLUMN_WITHOUT_CHECKBOX,
            customWidth: WIDTH_COLUMN_FIXED,
            classNameContainerTooltip: WIDTH_TOOLTIP_FIXED_COLUMN,
        },
        {
            field: 'releaseDate',
            label: t('release_date'),
            dateFormat: DATE_TIME_FORMAT_NAME_MODEL.slash,
            datetime: false,
            render: (value, row) => {
                if (!value && !row.releaseHour) return  EMPTY_VALUES.DEFAULT;

                return `${value} ${militaryHourToTimeString(row.releaseHour)}`;
            },
        },
        {
            field: 'servingDate',
            label: t('cafeteria_serving_date'),
            dateFormat: DATE_TIME_FORMAT_NAME_MODEL.slash,
            datetime: false,
            render: (value) => {
                return value;
            },
        },
        {
            field: 'foodieMealTypeId',
            label: t('meal_type'),
            render: (value) => {
                const mealKey = MealTypeEnum[value]?.name;
                const meal = mealKey ? t(mealKey) : null;
                if (!meal) return null;
                return (
                    <div className='d-flex justify-content-center'>
                        <CustomChip
                            legend={meal}
                            fontColor={colors.secondary700}
                            borderColor={colors.secondary150}
                            background={colors.secondary100}
                        />
                    </div>
                );
            },
        },
        {
            field: 'foodieCourseTypeId',
            label: t('course_type'),
            render: (value) => {
                const categoryName = DishCategoryEnum[value]?.name || EMPTY_VALUES.DEFAULT;

                return (
                    <CustomChip
                        fontColor={colors.secondary700}
                        borderColor={colors.secondary150}
                        background={colors.secondary100}
                        legend={
                            <CustomTooltip text={t(categoryName)}>
                                {t(categoryName)}
                            </CustomTooltip>
                        }
                        variant={'compact'}
                    />
                );
            }
        }
    ];

    // Renders the dropdown menu with options for each row
    const renderOptionsMenu = (item, index) => {
        return (
            <>
                <DropDownMenuProfile
                    openMenu={openMenu}
                    handleMenuToggle={handleMenuToggle}
                    menuId={`menu-${item.id}`} // Unique ID for each menu
                >
                    <DropDownMenuItem
                        id={'btn_ma_details_' + item.id}
                        index={index}
                        handleClose={handleClose}
                        name={t('details')}
                        icon={<DetailsIconsOptions />}
                        click={() => {
                            navigate(`${routes.foodieMenu.details}${item.id}`);
                        }}
                    />

                    {/* Show update option if in development mode or user has update permission */}
                    {isFutureDate(item) && (DEV || permission?.includes(permissionObj?.WEB_FOODIE_MENU_UPDATE)) && (
                        <DropDownMenuItem
                            id={'btn_ma_update_' + item.id}
                            index={index}
                            handleClose={handleClose}
                            name={t('update')}
                            icon={<UpdateIconsOptions />}
                            click={() => {
                                navigate(`${routes.foodieMenu.update}${item.id}`);
                            }}
                            url={{
                                pathname: `${routes.foodieMenu.update}${item.id}`,
                                state: {
                                    backUrl:{
                                        pathname: routes.foodie.list,
                                        state: {
                                            currentTab: TABS_FOODIE.MENUS.INDEX,
                                            currentSubView: SUB_VIEW_MODEL.MENUS.MENUS
                                        }
                                    }
                                }
                            }}
                        />
                    )}

                    {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_MENU_CLONE)) && (
                        <DropDownMenuItem
                            id={'btn_ma_clone_' + item.id}
                            index={index}
                            handleClose={handleClose}
                            name={t('clone')}
                            icon={<CloneIconOptions />}
                            url={{
                                pathname: `${routes.foodieMenu.clone}`,
                                state: {
                                    cloneId: item.id,
                                    backUrl:{
                                        pathname: routes.foodie.list,
                                        state: {
                                            currentTab: TABS_FOODIE.MENUS.INDEX,
                                            currentSubView: SUB_VIEW_MODEL.MENUS.MENUS
                                        }
                                    }
                                }
                            }}
                        />
                    )}

                    {isFutureDate(item) && (DEV || permission?.includes(permissionObj?.WEB_FOODIE_MENU_DELETE)) &&
                        <DropDownMenuItem
                            index={index}
                            handleClose={handleClose}
                            name={t("delete")}
                            fontColor='font-color-error-600'
                            iconColor={"icon-color-error-code-600"}
                            icon={<DeleteIconsOptions/>}
                            click={() => {
                                handleDeleteItem(item);
                            }}
                        />
                    }

                </DropDownMenuProfile>
            </>
        );
    };



    return {
        t,
        DEV,
        permission,
        searchId,
        rowsPerPage,
        setSimpleSearch,
        handleCheckboxChange,
        pagination,
        deleteModalShow,
        handleDeleteSelected,
        handleDeleteModalClose,
        selectForDelete,
        handleShowMenu,
        handleShowCalendar,
        handleShowMealForecast,
        resultsToShow,
        setResultsToShow,
        columns,
        renderOptionsMenu,
        navigate,
        handleDeleteAll,
        searchMealForecast,
        isFutureDate,
        deletePermission
    };
};

export default MenuApp;
